export function prepareUserNames(firstName: string, lastName: string) {
  const isDefaultBackendLastName = lastName === "/";
  if (isDefaultBackendLastName) {
    const defaultFirstNameArray = firstName.split(/[.+-_]/g);
    firstName = defaultFirstNameArray[0];
    lastName = defaultFirstNameArray.slice(1).join(" ");
  }
  return { isDefaultBackendLastName, firstName, lastName };
}
